export const lists = [new Array(3).fill(' '), new Array(3).fill(' ')];
export const textCards = new Array(4).fill(' ');
